var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Recursively traverses the `submitData` object to collect all embedded file objects
 * and replace them with generated attachment URLs using the provided callback.
 *
 * @param {any} submitData - The form data object that may contain files to extract.
 * @param {(entityKey: string) => Promise<string>} generateAttachmentUrl - A function that takes an entity key and returns a URL for the uploaded file.
 * @returns {Promise<{ files: { file: File; entityKey: string }[]; submitData: any }>}
 *          A promise that resolves to an object containing the collected files and the updated `submitData`.
 */
export function collectFilesAndFilterData(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
submitData, generateAttachmentUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const files = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filterData = (data) => __awaiter(this, void 0, void 0, function* () {
            for (const key of Object.keys(data)) {
                if (key === '.dataObject' && data['.dataObject']) {
                    if (data['.dataObject'].type === 'file') {
                        const entityKey = data['entityKey'];
                        files.push({
                            entityKey,
                            file: data['.dataObject'].file,
                        });
                        delete data['.dataObject'];
                        data['url'] = yield generateAttachmentUrl(entityKey);
                        return data;
                    }
                }
                if (data[key] && typeof data[key] === 'object') {
                    yield filterData(data[key]);
                }
            }
            return data;
        });
        yield filterData(submitData);
        return {
            files,
            submitData,
        };
    });
}
